<template>
  <div class="view-container">
    <el-drawer
      ref="BjDrawerForm"
      class="drawer-data-form-20210720"
      :form="form"
      :visible.sync="visible"
      size="680px"
    >
      <div>
        <BjDivider>{{ $t('CustomerFunction.steptitle') }}</BjDivider>
        <div style="height: 625px;margin-left: 100px;">
          <el-steps direction="vertical" :active="active" finish-status="success" process-status="finish">
            <!--  1.Request Submitted(申请提交) 2.Docs Approved（文件审批） 3.Finance Setup（财务审批）   4.Account Created（ERP账号创建）  5.IT Solution（IT实施） 6.Final Check（最终确认） -->
            <el-step :title="$t('CustomerFunction.step1')" :description="$t('CustomerFunction.steps1')"></el-step>
            <el-step :style="active >= 1 ? 'cursor: pointer;' : 'cursor: default;'" :title="$t('CustomerFunction.step2')" :description="$t('CustomerFunction.steps2')" @click.native="openInside()"></el-step>
            <el-step :style="active >= 2 ? 'cursor: pointer;' : 'cursor: default;'" :title="$t('CustomerFunction.step3')" :description="$t('CustomerFunction.steps3')" @click.native="openFinaForm()"></el-step>
            <el-step :style="active >= 3 ? 'cursor: pointer;' : 'cursor: default;'" :title="$t('CustomerFunction.step4')" :description="$t('CustomerFunction.steps4')" @click.native="goUser()"></el-step>
            <el-step :style="active >= 4 ? 'cursor: pointer;' : 'cursor: default;'" :title="$t('CustomerFunction.step5')" :description="$t('CustomerFunction.steps5')" @click.native="openFileUpload()"></el-step>
            <el-step :title="$t('CustomerFunction.step6')" :description="$t('CustomerFunction.steps6')"></el-step>
            <el-step :title="$t('CustomerFunction.step7')" :description="$t('CustomerFunction.steps7')"></el-step>
            <el-step :title="$t('CustomerFunction.step8')" :description="$t('CustomerFunction.steps8')"></el-step>
          </el-steps>
        </div>
        <div class="footer" style="margin-top:50px">
          <el-button v-if="showButton" style="width: 200px;" type="primary" @click="handleConfirm">{{ $t('okText') }}</el-button>
        </div>
        <!-- 第二步文件侧边栏 / 二级侧边栏 -->
        <InsideDrawer ref="InsideDrawer"/>
      </div>
    </el-drawer>
    <!-- 第三步财务侧边栏 / 二级侧边栏 -->
    <FinanceForm ref="FinanceForm" @financeReFresh="financeReFresh"/>
    <!-- 第五步文件侧边栏 / 二级侧边栏 -->
    <ChecklistFile ref="ChecklistFile" @reFresh="reFresh"/>
  </div>
</template>
<script>
import { funConfigApi } from '@/api';
import InsideDrawer from './InsideDrawer.vue';
import FinanceForm from './FinanceForm.vue';
import ChecklistFile from './ChecklistFile.vue';

export default {
  components: {
    InsideDrawer,
    FinanceForm,
    ChecklistFile,
  },
  data() {
    return {
      // 表单参数
      openType: null,
      visible: false,
      colSpan:12,
      customerNameList:[],
      form: {},
      showButton: false,
      active: 1,
      auditID: null,
      auditType: false,
      stepOperator: null,
    };
  },
  methods: {
    // 接收参数打开侧边栏
    show(row) {
      this.form = row || {};
      this.visible = true;
      this.isShowButton(row.id)
    },
    // 判断是否可以展示 审核 按钮
    isShowButton(id){
      // 获取当前流程完成度
      const promise1 = funConfigApi.taskOnboardingList({onboardingId:id});
      // 获取审核参数
      const promise2 = funConfigApi.progressOnboardingList({onboardingId:id});
      Promise.all([promise1, promise2])
        .then(values => {
          const [res1, res2] = values;
          // console.log(res1,res2);
          if (res1.length>0) {
            // 审核按钮参数
            this.auditID = res1[0].id
            // 审核侧边栏是否可以编辑
            // this.auditType = true
          }
          if (res2.length>0) {
            if(res2[res2.length - 1].status == 1){
              this.active = res2.length
            }else{
              this.active = res2.length - 1
            }
          }
          if (res1.length>0 && res2.length>0) {
            this.showButton = true
          }else{
            this.showButton = false
          }
        });
    },
    // 审核
    handleConfirm() {
      // console.log(this.active,'this.active');
      // 判断每一步是否可以审核：第三步需要有bpCode，第四步需要有cusId/userId，第五步需要上传文件checklistFileList
      if(this.active==2){
        if(!this.form.bpCode) return this.$message.warning(this.$t('CustomerFunction.stepTips1'));
      }
      if(this.active==3){
        if(!this.form.cusId || !this.form.userId) return this.$message.warning(this.$t('CustomerFunction.stepTips2'));
      }
      if (this.active == 4) {
        const hasChecklistFile = Array.isArray(this.form.checklistFileList) &&
          this.form.checklistFileList.some(file => file && file.name && file.url);
        if (!hasChecklistFile) return this.$message.warning(this.$t('ExcelConfig.upload'));
      }
      funConfigApi.approveOnboardingList(this.auditID).then(res => {
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            // 财务审核完成后清掉里层数据
            if(this.active==2){this.$refs.FinanceForm.clearForm()}

            this.auditType = false
            this.visible = false;
            this.reFresh();
          }, 500);
        }
      });
    },
    // 2文件审批侧边栏 ： 下载文件
    openInside(){
      if(this.active >= 1){
        this.$refs.InsideDrawer.queryParams.id = this.form.id
        this.$refs.InsideDrawer.drawer = true
        this.$refs.InsideDrawer.reFresh()
      }
    },
    // 3财务编辑侧边栏 ： 暂时一个输入框 
    openFinaForm(){
      // console.log(this.active,'财务');
      this.$refs.FinanceForm.queryParams.id = this.form.id
      if(this.active >= 2){
        funConfigApi.getOnboardingCheckByBp({onboardingId:this.form.id}).then(res => {
          // 只有账号是 财务 并且步骤对应财务审批 才可以进去编辑bpcode
          if (res.message == 1 && this.active == 2) {
            this.$refs.FinanceForm.auditType = true;
          }else{
            this.$refs.FinanceForm.auditType = false;
          }
        });
        setTimeout(() => {
          this.$refs.FinanceForm.show(this.form);
        }, 300);
      }
    },
    // 3财务输完bpcode后重新刷新审核按钮
    financeReFresh(bpCode) {
      this.form.bpCode = bpCode || null
      this.isShowButton(this.form.id)
      console.log(this.form,'financeReFresh.form');
    },
    // 4ERP账户创建 ： 跳新增用户页面并调用 类详情接口 进行数据回显操作 getOnboardingCheckByCustomer
    goUser(){
      // console.log(this.active,'ERP');
      if(this.active == 3){
        // 如果有userid，跳转编辑用户
        if(this.form.userId){
          this.visible = false;
          this.$router.push({
            name: 'BusinessUserCustomerEditCSG',
            query: { pageType: 'canEdit',userId: this.form.userId },
          });
        }else{
          // 否则判断当前账号有无权限新增erp用户 后 跳转新增用户
          funConfigApi.getOnboardingCheckByCustomer({onboardingId:this.form.id}).then(res => {
            // console.log(res,'ERP');
            if (res.message == 1) {
              this.visible = false;
              this.$router.push({
                name: 'BusinessUserCustomerAddCSG',
                query: { pageType: 'canEdit',onboardingId: this.form.id },
              });
            }else{
              return this.$message.warning(this.$t('CustomerFunction.stepTips3'));
            }
          });
        }
      }
      // IT实施/最终确认 ： 跳编辑用户页面
      if(this.active >= 4){
        this.visible = false;
        this.$router.push({
          name: 'BusinessUserCustomerEditCSG',
          query: { pageType: 'canEdit',userId: this.form.userId },
        });
      }
    },
    // 第五步文件上传以及展示
    openFileUpload(){
      if(this.active >= 4){
        funConfigApi.getOnboardingCheckByChecklist({onboardingId:this.form.id}).then(res => {
          console.log(res,'5res');
          // 1可以上传 0不可以上传
          if (res.message == 1 && this.active == 4) {
            this.$refs.ChecklistFile.canUpload = true;
          }else{
            this.$refs.ChecklistFile.canUpload = false;
          }
        });
        setTimeout(() => {
          this.$refs.ChecklistFile.show(this.form);
        }, 300);
      }
    },
    
    reFresh() {
      this.visible = false
      this.$emit('reFresh');
    },
  },
};
</script>
<style lang="scss">
/***/
.drawer-data-form-20210720 {
  .el-drawer__container {
    padding: 8px;
  }
  .el-drawer__header {
    margin-bottom: 4px;
  }
  .el-drawer__body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }
  .el-drawer__body form {
    flex: 1;
    max-height: 100%;
    overflow-y: auto;
    padding: 16px;
  }
  .el-drawer__body .footer button {
    width: 200px;
  }
  .footer.has-title {
    margin-bottom: 45px;
  }
}
</style>
